import { bulkProcessPayslips } from "@/api/payslips";
import { CustomDatePicker } from "@/components/form/CustomDatePicker";
import { Button } from "@/components/ui/button";
import { usePayContext } from "@/context/PayContext";
import { GetPayslipUserResult } from "@/models/payslips.model";
import { months } from "@/utils/date-format";
import { RowSelectionState } from "@tanstack/react-table";
import React, { useEffect } from "react";

interface Props {
  rowSelection: RowSelectionState;
  unprocessedPayUsers: GetPayslipUserResult[];
  deleteUnprocessedRows: (usersToRemove: number[]) => void;
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>;
}
function ProcessPayForm({
  setRowSelection,
  rowSelection,
  unprocessedPayUsers,
  deleteUnprocessedRows,
}: Props) {
  const { selectedMonth, selectedYear, setIsProcessListChanged } =
    usePayContext();
  const [date, setDate] = React.useState<Date | undefined>(undefined);
  console.log(rowSelection);

  useEffect(() => {
    console.log("rowSelection", rowSelection);
  }, [rowSelection]);

  const handleProcess = async () => {
    if (!date) return;

    const selectedUsers = unprocessedPayUsers.filter(
      (_, index) => rowSelection[index]
    );
    const payslips = selectedUsers.map((user) => ({
      userId: user.user.id,
      month: months.indexOf(selectedMonth) + 1,
      year: Number(selectedYear),
    }));

    setIsProcessListChanged(false);
    const res = await bulkProcessPayslips({ payDate: date, payslips });
    if (res) {
      deleteUnprocessedRows(selectedUsers.map((user) => user.user.id));
      setIsProcessListChanged(true);
      setRowSelection({});
    }
  };
  return (
    <div className="flex gap-3 items-center">
      <CustomDatePicker
        date={date}
        setDate={setDate}
        defaultPlaceholder="Select pay date"
        disabled={Object.keys(rowSelection).length === 0}
      />
      <Button
        disabled={Object.keys(rowSelection).length === 0 || !date}
        onClick={handleProcess}
      >
        Process Pay
      </Button>
    </div>
  );
}

export default ProcessPayForm;
